import { StyledEngineProvider } from '@mui/material'
import { RouterProvider } from '@tanstack/react-router'
import { Amplify } from 'aws-amplify'
import { SnackbarProvider } from 'notistack'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import awsConfig from './awsConfig'

import { CognitoProvider } from './context/CognitoContext'
import { CustomQueryClientProvider } from './context/QueryClientProvider'
import { router } from './routes'

Amplify.configure(awsConfig)

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <StyledEngineProvider injectFirst>
      <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <CustomQueryClientProvider>
          <CognitoProvider>
            <RouterProvider router={router} />
          </CognitoProvider>
        </CustomQueryClientProvider>
      </SnackbarProvider>
    </StyledEngineProvider>
  </StrictMode>
)
